import moment from 'moment';
import * as _ from 'lodash';

import * as types from './types';
import { loading, success, error } from 'State/actions';
import { TransactionSummaryEnum } from 'Common/FieldEnum';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';

export const getExistingTranSummaryDtls = filtersOptions => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.GET_EXISTING_TRAN_SUMMARY_LIST_LOADING, true));
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        'TranSummary/GetExistingTranSummaryDtls',
        filtersOptions
      );
      dispatch(
        success(
          types.GET_EXISTING_TRAN_SUMMARY_LIST_DATE_DATA,
          response.data.Data
        )
      );
    } catch (err) {
      dispatch(error(types.GET_EXISTING_TRAN_SUMMARY_LIST_LOADING_ERROR, err));
    } finally {
      dispatch(loading(types.GET_EXISTING_TRAN_SUMMARY_LIST_LOADING, false));
    }
  };
};
export const getTranBeginEndDate = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.GET_TRAN_SUMMARY_BEGIN_END_DATE_LOADING, true));
    try {
      const response = await MPWWebApi.getGeneric(
        `TranSummary/GetBeginEndDtFromTranSummary`
      );
      const currentDate = moment();
      let data = _.has(response, 'data.Data') ? response.data.Data : null;
      data =
        data &&
        data[TransactionSummaryEnum.BeginDT] &&
        data[TransactionSummaryEnum.EndDT]
          ? {
              [TransactionSummaryEnum.BeginDT]: moment(
                data[TransactionSummaryEnum.BeginDT]
              ).format(DATE_FORMAT_FOR_UI),
              [TransactionSummaryEnum.EndDT]: moment(
                data[TransactionSummaryEnum.EndDT]
              ).format(DATE_FORMAT_FOR_UI),
            }
          : {
              [TransactionSummaryEnum.BeginDT]: currentDate.format(
                DATE_FORMAT_FOR_UI
              ),
              [TransactionSummaryEnum.EndDT]: currentDate.format(
                DATE_FORMAT_FOR_UI
              ),
            };

      dispatch(success(types.SET_TRAN_SUMMARY_BEGIN_END_DATE, data));
    } catch (err) {
      dispatch(error(types.GET_TRAN_SUMMARY_BEGIN_END_DATE_LOADING_ERROR, err));
    } finally {
      dispatch(loading(types.GET_TRAN_SUMMARY_BEGIN_END_DATE_LOADING, false));
    }
  };
};
export const clearTransactionSummaryError = () => {
  return {
    type: types.CLEAR_TRANSACTION_SUMMARY_ERROR,
  };
};
export const getExistingTranSummaryPrint = filterOption => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.GET_EXISTING_TRAN_SUMMARY_PRINT_LOADING, true));
    try {
      await MPWWebApi.postGenericInsertUpdate(
        'TranSummary/GetExistingTranSummaryPrint',
        filterOption
      );
    } catch (err) {
      dispatch(error(types.GET_EXISTING_TRAN_SUMMARY_PRINT_LOADING_ERROR, err));
    } finally {
      dispatch(loading(types.GET_EXISTING_TRAN_SUMMARY_PRINT_LOADING, false));
    }
  };
};
export const setToDateMin = payload => {
  return {
    type: types.SET_TO_DATE_MIN,
    payload,
  };
};
export const setFromDateMax = payload => {
  return {
    type: types.SET_FROM_DATE_MAX,
    payload,
  };
};



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/transactionSummary/state/TransactionSummaryList/actions.js